import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Tag from "../components/Tag";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
  staggerItemVariants,
} from "../hooks/useScrollAnimation";

import "./Process.css";

// Import step illustrations
import stepsVision from "../assets/illustrations/steps-vision.jpeg";
import stepsApprove from "../assets/illustrations/steps-approve.jpeg";
import stepProduct from "../assets/illustrations/step-product.jpeg";

// Map illustrations to process steps
const STEP_IMAGES = [stepsVision, stepsApprove, stepProduct];

export default function Process() {
  const { t } = useTranslation();
  const containerVariants = getScrollAnimationVariants("staggerChildren");

  const items = [
    {
      tag: t("process.step1Tag"),
      title: t("process.step1Title"),
      description: t("process.step1Desc"),
    },
    {
      tag: t("process.step2Tag"),
      title: t("process.step2Title"),
      description: t("process.step2Desc"),
    },
    {
      tag: t("process.step3Tag"),
      title: t("process.step3Title"),
      description: t("process.step3Desc"),
    },
  ];

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={defaultScrollViewportSettings}
      variants={containerVariants}
    >
      <div className="section-title center">
        <h2>{t("process.title")}</h2>
        <p>{t("process.subtitle")}</p>
      </div>

      <div className="process-grid">
        {items.map(({ tag, title, description }, index) => (
          <motion.div
            key={index}
            className="process-card"
            variants={staggerItemVariants}
          >
            <div className="process-card-content">
              <Tag style={{ backgroundColor: `var(--tag-color-${index + 1})` }}>
                {tag}
              </Tag>
              <h3 className="process-title">{title}</h3>
              <p className="process-description">{description}</p>
            </div>
            <img
              src={STEP_IMAGES[index]}
              alt={`${title} illustration`}
              className="process-placeholder"
            />
          </motion.div>
        ))}
      </div>
      {items.length > 1 && <div className="process-connector" />}
    </motion.section>
  );
}
